import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { EditableTalentProfile } from "src/components/talent/EditableTalentProfile"

export const TalentProfile = () => {

    return (
        <PageLayout
            header={<PageHeader
                title="My Profile"
            />
        }>
            <EditableTalentProfile />
        </PageLayout>
    )
}